import { parsePhoneNumberFromString } from "libphonenumber-js";

export function normalizePhoneToE164(value, defaultCountry = "IN") {
  const raw = String(value || "").trim();
  if (!raw) {
    return { valid: false, e164: "" };
  }

  const phone = parsePhoneNumberFromString(raw, defaultCountry);
  if (!phone || !phone.isValid()) {
    return { valid: false, e164: "" };
  }

  return { valid: true, e164: phone.number };
}

export function isValidE164(value) {
  return /^\+[1-9]\d{6,14}$/.test(String(value || "").trim());
}

export function normalizePhoneForWhatsApp(value) {
  const digits = String(value || "").replace(/\D/g, "");
  return {
    valid: /^[1-9]\d{6,14}$/.test(digits),
    digits,
  };
}
